import { Injectable } from '@angular/core';
import { Router, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import constants from '../../../utility/constants';
import { ModuleService } from '../../module.service';
import { ToastrService } from 'ngx-toastr';

@Injectable()
export class BlogAuthGaurd  {
  constructor(
    private ms: ModuleService,
    private router: Router,
    private toast: ToastrService
  ) {}

  canLoad():
    | boolean
    | UrlTree
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree> {
    return this.shouldLoadOrActivate();
  }

  canActivate():
    | boolean
    | UrlTree
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree> {
    return this.shouldLoadOrActivate();
  }

  private shouldLoadOrActivate() {
    if (this.ms.userHas(constants.admin.modules.blog)) return true;
    this.toast.info("No sufficient permission to access 'Blog Management'");
    this.router.navigate(['/admin/dashboard']);
    return false;
  }
}
